import ProductAttributesApiV2 from 'api/v2/admins/product-attributes-api-v2'
import ReactMultiSelectSearchField from 'components/molecules/react-multiselect-search-field'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { STATUS_OPTION } from 'domains/product-attribute/constants'

const propTypes = {
  code       : PropTypes.string,
  name       : PropTypes.string,
  label      : PropTypes.string,
  required   : PropTypes.bool,
  isCuration : PropTypes.bool
}

const defaultProps = {
  isCuration: false
}

/**
 * Allow multi select options from particular Product Attribute.
 * Only to be used within a Formik component
 * @param {string} code - Product Attribute code
 * @param {string} name - Field name in the formik bag
 * @param {string} label - Field label
 * @param {bool} required - Required badge will show if it set true
 * @param {bool} isCuration - Set true if it's for curation form
 */
const ProductAttributeMultiSelectField = ({
  code,
  name,
  label,
  required,
  isCuration,
  ...props
}) => {
  const [ options, setOptions ]     = useState([])
  const [ isLoading, setIsLoading ] = useState(true)


  useEffect(() => {
    if (options.length > 0) return

    const optionsFormCache = sessionStorage.getItem(code)

    if (optionsFormCache) {
      const jsonOptions      = JSON.parse(optionsFormCache)
      const formattedOptions = formatOptions(jsonOptions)

      setOptions(formattedOptions)
      setIsLoading(false)
    }
    else {
      const optionEndpoint = isCuration
        ? ProductAttributesApiV2.getCurationOptions({ attributeCode: code })
        : ProductAttributesApiV2.getOptions({ attributeCode: code, additionalFilters: { status: STATUS_OPTION.ENABLED } })

      optionEndpoint.then((response) => {
        const options = response.data.options
        sessionStorage.setItem(code, JSON.stringify(options))
        const formattedOptions = formatOptions(options)

        setOptions(formattedOptions)
        setIsLoading(false)
      })
        .catch(() => {
          alert(`Failed: Get Attribute ${code}`)
        })
    }
  }, [ code, isCuration, options.length ])


  /**
   * Format options to proper structure for react-select
   * @param {array} options - list of option
   */
  const formatOptions = (options) => options.map((option) => ({
    value : option.id,
    label : option.label
  }))


  return (
    <ReactMultiSelectSearchField
      name={ name }
      label={ label }
      required= { required }
      isLoading={ isLoading }
      dataList={ options }
      { ...props }
    />
  )
}

ProductAttributeMultiSelectField.propTypes    = propTypes
ProductAttributeMultiSelectField.defaultProps = defaultProps

export default ProductAttributeMultiSelectField
